import styled from 'styled-components'
import { NATIVE_BASE_COLORS, FONT_SIZE } from '../../../../../themes'

export const MeetingDetailStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .meeting-info__box__row {
    display: flex;
    align-items: flex-start;

    p {
      margin: 0;
    }
  
    &__detail {
      max-width: 460px;
    }
  }

  .meeting-info__box__row__title {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 30%;
    min-width: 170px;
    color: ${NATIVE_BASE_COLORS.TEXT[500]};


    &__icon {
      display: flex;
      align-items: center;
    }
  }   

  .meeting-info__box__row__guest {
    display: flex;
    align-items: flex-start;

    p {
      margin: 0;
    }

    &__box {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 10px;
    }

    &__view-all-button {
      border: 0;
      padding: 0;
      background: none;
      cursor: pointer;
      /* color: ${NATIVE_BASE_COLORS.PRIMARY[300]}; */
      color: ${props => props.colorTheme ? props.colorTheme.MAIN : NATIVE_BASE_COLORS.PRIMARY[300]};
      font-size: ${FONT_SIZE.XXS};
      font-family: NunitoRegular;
      text-align: left;
    }

    &__view-all-button:hover {
      opacity: 0.7;
    }
  }
`
